export default __webpack_public_path__ + "static/media/coder.49ac8f77.svg";